import { FlightType } from './flights';
import { ILocationContext } from './location-context';
import { ITime, ITimeComparison } from './time';

export interface IDockingContext {
    deviceId: string;
    state: string;
    stateName: string;
    messages: string[];
    commands: ICommand[];
    conMonUsed: boolean;
    conMonActive: boolean;
    requiredMonitors?: number;
    aliveMonitors?: number;
    criticalCommands: ICommand[];
    info: IDockingInfo;
    cameraURL: string;
    gse: IGseEntity[];
    time: ITime;
    timeComparison: ITimeComparison;
    inSelectionMenu: boolean;
    relatedCenterlineIds: string[];
    usersMonitoring: IUserMonitoring[];
}

export interface IDockingInfo {
    centerline: string;
    flight?: string;
    acType?: string;
    regNr?: string;
    flightType?: FlightType;
}

export interface ICommand {
    id: string;
    text: string;
    // NOTE: This prop is capitalized because the backend equivalent
    // is also capitalized because of historical reasons and backward compatibility
    // Don't change unless discussed with backend
    SelectionList?: string;
    selection?: string;
    context?: string;
    source?: string;
    fieldDef?: IFieldDefItem[];
    fields?: IField[];
    PIN?: string;
    restrictions?: string[];
    catg?: CommandCategory;
}

/**
 * Each command can have a category which defines the expected behaviour on the Operator panel by the DGS.
 * Values of each category is defined in the DGS and has to be coordinated withing the team.
 * No provided command category is the same as a normal command.
 */
export enum CommandCategory {
    NORMAL = '0',
    MAINTENANCE = '1',
    CRITICAL_CONFIRM = '2',
    SOFT_KEY_ONLY = '3',
    CRITICAL_NO_CONFIRM = '4',
    NORMAL_CONFIRM = '5'
}

export const CRITICAL_COMMANDS = [CommandCategory.CRITICAL_NO_CONFIRM, CommandCategory.CRITICAL_CONFIRM];
export const CONFIRMATION_COMMANDS = [CommandCategory.NORMAL_CONFIRM, CommandCategory.CRITICAL_CONFIRM];

export interface IUserMonitoring {
    monitorUID: string;
    userName: string;
}

export interface IConMonStatusMessage {
    locationContext: ILocationContext;
    operator: string;
    userMonitoring: IUserMonitoring;
}

export interface ICommandForBackend {
    id: string;
    operator: string;
    source?: string;
    selection?: string;
    requiredMonitors?: number;
    aliveMonitors?: number;
    fields?: IField[];
}

export interface IConMonStatusForBackend {
    operator: string;
    userMonitoring: IUserMonitoring;
}

export interface IFieldDefItem {
    type: string;
    text: string;
    key: string;
    value: string;
}

export interface IField {
    key: string;
    value: string;
}

export interface ICommandContext {
    locationContext: ILocationContext;
    command: ICommand;
    dockingInfo?: IDockingInfo;
}

export enum GseType {
    GPU,
    PBB,
    PCA
}

export enum GseStatus {
    Ready,
    Connected,
    Error
}

export interface IGseEntity {
    gseType: GseType;
    gseStatus: GseStatus;
}
